import { render, staticRenderFns } from "./PForm.vue?vue&type=template&id=27eefc6c&scoped=true"
import script from "./PForm.vue?vue&type=script&lang=ts"
export * from "./PForm.vue?vue&type=script&lang=ts"
import style0 from "./PForm.vue?vue&type=style&index=0&id=27eefc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eefc6c",
  null
  
)

export default component.exports